import { Node } from 'tiptap'
import Iframe from '@/components/tiptap/extensions/Iframe.vue'

export default class IframeNode extends Node {
	get name() {
		return 'iframe'
	}

	get schema() {
		return {
			attrs: {
				src: {
					default: null
				},
				width: {
					default: null
				},
				height: {
					default: null
				},
				allowfullscreen: {
					default: null
				}
			},
			group: 'block',
			selectable: false,
			parseDOM: [{
				tag: 'iframe',
				getAttrs: dom => ({
					src: dom.getAttribute('src'),
					width: dom.getAttribute('width'),
					height: dom.getAttribute('height'),
					allowfullscreen: dom.getAttribute('allowfullscreen')
				})
			}],
			toDOM: node => ['iframe', {
				src: node.attrs.src,
				width: node.attrs.width,
				height: node.attrs.height,
				frameborder: 0,
				allowfullscreen: node.attrs.allowfullscreen
			}]
		}
	}

	get view() {
		return Iframe
	}
}